import formatServerError from 'src/common/util/serverErrorFormatter';

export type ErrorResponse = {
  status: number;
  data: {
    type: string;
    errors: DRFError[];
  };
};

type DRFError = {
  code: string;
  detail: string;
  attr: string;
};

export const formatAssignmentDeleteErrors = (response: ErrorResponse) => {
  if (response.status !== 400) {
    return formatServerError(response);
  }

  return response.data.errors.map((err) => err.detail);
};
